// extracted by mini-css-extract-plugin
export default {"alert":"q5yh9J","alertMessage":"Bmxpbw"};